/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports`
 * @name CogsPurchaseHistoryCtrl
 */
angular.module('mercury.modules.reports.cogs')
.controller('CogsPurchaseHistoryCtrl', ["dialog", "$scope", "$q", "StockItems", "ReportsCogsPosItemLinkService", "dialogData", "StockReceived", "StockCost", function(dialog, $scope, $q,
  StockItems, ReportsCogsPosItemLinkService, dialogData, StockReceived, StockCost) {

  $scope.endDate = dialogData.endDate;
  $scope.cogsStockCostDocumentId = dialogData.cogsStockCostDocumentId;
  $scope.cogsStockCostDocumentType = dialogData.cogsStockCostDocumentType;
  $scope.purchaseOrdersStartDate = dialogData.startDate;
  $scope.purchaseOrdersEndDate = dialogData.endDate;

  function loadPurchaseOrders(startDate, endDate, stockItemId) {
    $scope.loading = StockReceived.getStockReceivedsByDateRange(startDate, endDate, 'Received', stockItemId, true).$promise;
    $scope.loading.then(function(documents) {
      if (documents.length > 0) {
        $scope.documentLines = [];

        // flatten out the purchase orders into a single list of lines
        documents.forEach(function(document) {
          document.lines.forEach(function(line) {
            if (line.itemId == $scope.item.id) {
              $scope.documentLines.push({
                id: document.id,
                type: document.type,
                referenceNumber: document.type == 'Invoice' ? document.invoiceNumber : document.purchaseOrderNumber,
                creditRequest: document.creditRequest,
                item: line.itemName,
                link: '',
                receivedAt: document.receivedAt,
                supplierName: document.supplierName,
                stockUnit: line.unitName,
                unitCost: line.unitCost,
                quantity: line.quantityReceived,
                totalCost: line.unitCost * line.quantityReceived
              });
            }
          });
        });
      }
    });
  }

  $scope.loading = $q.all({
    item: StockItems.getStockApi(dialogData.stockItemId, false).$promise,
    cost: StockCost.get([`${dialogData.stockItemId},${dialogData.endDate}`])
  });
  $scope.loading.then(function(result) {
    $scope.item = result.item;
    var itemStockCost = result.cost.itemCosts[result.item.id][0]

    // If the unit name starts with a letter then we prefix it with '1 ' for
    // presentation purposes, otherwise we prefix with '1 x '. This means we have
    // "1 Serving", and "1 x 200gm" displayed to end-users.
    if (itemStockCost.unitName.match(/^[a-z].*/i)) {
      $scope.cogsStockUnitName = 1 + ' ' + itemStockCost.unitName;
    } else {
      $scope.cogsStockUnitName = 1 + ' x ' + itemStockCost.unitName;
    }

    $scope.cogsUnitCost = itemStockCost.cost * itemStockCost.unitRatio;

    $scope.documentLines = [];

    if (result.item.currentPriceDocumentId == null) {
      $scope.documentLines.push({
        itemId: dialogData.stockItemId,
        item: 'Latest Price Set Manually',
        date: dialogData.endDate,
        supplier: '',
        stockUnit: '',
        unitCost: result.item.globalPrice,
        quantity: undefined,
        totalCost: ''
      });
    }

    // Initial load of PO data, needs to happen after item data is received
    loadPurchaseOrders(dialogData.startDate, dialogData.endDate, dialogData.stockItemId);
  });

  $scope.editItem = function(itemId) {
    dialog.open({
      templateUrl: 'modules/stock/item/edit.tpl.html',
      controller: 'StockItemEditCtrl',
      size: 'lg',
      resolve: {
        itemId: function() {
          return itemId;
        }
      }
    });
  };

  $scope.close = function() {
    dialog.close();
  };

  $scope.changePurchaseOrderDates = function() {
    loadPurchaseOrders(
      $scope.purchaseOrdersStartDate, $scope.purchaseOrdersEndDate, dialogData.stockItemId);
  };
}]);
